module.exports = __webpack_public_path__ + "media/shared/assets/fonts/InterDisplay/InterDisplay-Black-fb55d5da48c7bee4d80af9ec6cd28e3f.woff2";